import React from 'react';
import {getFormatedForm} from "../../../Models";
import filterListModel from '../../../Models/filterListModels/filterListModel';
import {SzBox, SzButton, SzCheckbox, SzInput, SzSelect} from '@suezenv/react-theme-components';
import {Form, Formik} from 'formik';
import {withTranslation} from 'react-i18next';
import SelectedFilter from './selectedFilter';
import classnames from 'classnames';
import SzDatePicker from '../../elements/SzDatePicker/SzDatePicker';
import {STATUS_LIST} from "../../../constants";
import moment from 'moment';
import referenceDataService, {ENDPOINTS as ReferenceDataEndpoints} from "../../../services/ReferenceDataService";

type FiltersState = {
  status: any;
  isValid: boolean;
  startDate: any;
  endDate: any;
  asset: any;
  address: any;
  demande: any;
  numeroIntervention: any;
  selectedFilter: any;
  focusedInput: any;
  document: boolean;
  itv: boolean;
  intervention: boolean;
  idvicr: any;
  codeSousDomaine: any;
  libelleIntervention: any;
  libelleCommune: any;
};

type SelectListOptions = {
  networkTypeOptions: any;
  interventionTypeOptions: any;
  interventionTownOptions: any;
};

type State = {
  filters: FiltersState;
  selectListOptions: SelectListOptions;
};

class FilterList extends React.Component<any, State> {
  state: State = {
    filters: {
      status: null,
      isValid: false,
      startDate: null,
      endDate: null,
      asset: '',
      address: '',
      demande: '',
      numeroIntervention: '',
      libelleIntervention: null,
      idvicr: '',
      selectedFilter: [],
      focusedInput: null,
      document: false, // the filter true means get only the interventions with document
      itv: true, // the filter true means get only the interventions with document type itv
      intervention: true, // the filter true means get only the asset with intervention
      codeSousDomaine: null,
      libelleCommune: null,
    },
    selectListOptions: {
      networkTypeOptions: [],
      interventionTypeOptions: [],
      interventionTownOptions: [],
    },
  };

  defaultStateFilters: FiltersState = {...this.state.filters};

  public async componentDidMount(): Promise<void> {
    this.setState((prevState: State) => ({filters: {...prevState.filters, ...this.props.filter}}));
    this.refreshSelectedFilters(this.props.filter);
    await this.fetchSelectListOptions();
  }

  public formatDate(date: any, functional = false): string {
    date = date.toDate();
    const toTwoDigit = (value: number) => (`0${value}`).slice(-2);
    if (functional) {
      return `${toTwoDigit(date.getDate())}/${toTwoDigit(date.getMonth() + 1)}/${date.getFullYear()}`;
    }
    return `${date.getFullYear()}-${toTwoDigit(date.getMonth() + 1)}-${toTwoDigit(date.getDate())}`;
  }

  public triggerFilters = (): void => {
    let filter: any = {};
    const {getFilteredItems, setItemFilter, type} = this.props;
    const {
      status,
      startDate,
      endDate,
      asset,
      demande,
      numeroIntervention,
      libelleIntervention,
      address,
      document,
      itv,
      intervention,
      idvicr,
      codeSousDomaine,
      libelleCommune
    } = this.state.filters;
    if ('intervention' === type) {
      if (null !== status) {
        filter.status = status;
      }
      if (asset) {
        filter.asset = asset;
      }
      if (demande) {
        filter.demande = demande;
      }
      if (numeroIntervention) {
        filter.numeroIntervention = numeroIntervention;
      }
      if (libelleIntervention) {
        filter.libelleIntervention = libelleIntervention;
      }
      if (libelleCommune) {
        filter.libelleCommune = libelleCommune;
      }
      if (address) {
        filter.address = address;
      }
      if (idvicr) {
        filter.idvicr = idvicr;
      }
      if (codeSousDomaine) {
        filter.codeSousDomaine = codeSousDomaine;
      }
      filter.document = document;
      filter.itv = itv;

      if (startDate && endDate) {
        filter.dateCreationMin = this.formatDate(startDate);
        filter.dateCreationMax = this.formatDate(endDate);
      }
    }
    if ('asset' === type) {
      filter.intervention = intervention;
    }

    setItemFilter(filter);
    getFilteredItems(filter, 1);

    this.refreshSelectedFilters(filter);
  };

  public changeHandle = (name: keyof FiltersState, event: any): void => {
    switch (name) {
      case 'document':
      case 'itv':
      case 'intervention':
        this.setState(prevState => ({
          filters: {...prevState.filters, [name]: !prevState.filters[name]}
        }));
        break;
      case 'status':
      case 'codeSousDomaine':
      case 'libelleIntervention':
      case 'libelleCommune':
        this.setState(prevState => ({filters: {...prevState.filters, [name]: event}}));
        break;
      default:
        const value = event.target.value;
        this.setState(prevState => ({filters: {...prevState.filters, [name]: value}}));
        break;
    }
  };

  public refreshSelectedFilters(filters: any) {
    const {t, searchQuery, type} = this.props;
    let elements: any = [];
    if (type === 'intervention') {
      if (filters.status) {
        elements.push(
          <SelectedFilter
            key='status'
            name='status'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.status.label}/>
        );
      }

      if (filters.asset) {
        elements.push(
          <SelectedFilter
            key='asset'
            name='asset'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.asset}
          />
        );
      }

      if (filters.demande) {
        elements.push(
          <SelectedFilter
            key='demande'
            name='demande'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.demande}
          />
        );
      }

      if (filters.numeroIntervention) {
        elements.push(
          <SelectedFilter
            key='numeroIntervention'
            name='numeroIntervention'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.numeroIntervention}
          />
        );
      }
      if (filters.libelleIntervention) {
        elements.push(
          <SelectedFilter
            key='libelleIntervention'
            name='libelleIntervention'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.libelleIntervention.label}
          />
        );
      }

      if (filters.libelleCommune) {
        elements.push(
          <SelectedFilter
            key="libelleCommune"
            name="libelleCommune"
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.libelleCommune.label}
          />
        );
      }

      if (filters.address) {
        elements.push(
          <SelectedFilter
            key='address'
            name='address'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.address}
          />
        );
      }

      if (filters.idvicr) {
        elements.push(
          <SelectedFilter
            key="idvicr"
            name="idvicr"
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.idvicr}
          />
        );
      }

      if (filters.codeSousDomaine) {
        elements.push(
          <SelectedFilter
            key="codeSousDomaine"
            name="codeSousDomaine"
            deleteHandler={this.deleteSelectedFilterHandler}
            label={filters.codeSousDomaine.label}
          />
        );
      }

      if (filters.document === true) {
        elements.push(
          <SelectedFilter
            key='document'
            name='document'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={t('filter.document')}
          />
        );
      }

      if (filters.itv === true) {
        elements.push(
          <SelectedFilter
            key='itv'
            name='itv'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={t('filter.itv')}
          />
        );
      }

      // filter range date
      if (filters.dateCreationMin && filters.dateCreationMax) {
        const {dateCreationMin, dateCreationMax} = filters;
        const labelRange = t('filter.filter_range', {
          startDate: moment(dateCreationMin).format('DD/MM/YYYY'),
          endDate: moment(dateCreationMax).format('DD/MM/YYYY')
        });
        elements.push(<SelectedFilter
          key='rangeDate'
          name='rangeDate'
          deleteHandler={this.deleteSelectedFilterHandler}
          label={labelRange}
        />);
      }
    }
    if (type === 'asset') {
      if (filters !== undefined && filters.intervention === true) {
        elements.push(
          <SelectedFilter
            key='intervention'
            name='intervention'
            deleteHandler={this.deleteSelectedFilterHandler}
            label={t('filter.intervention')}
          />
        );
      }
    }

    if (searchQuery) {
      elements.push(<SelectedFilter
        key='querySearch'
        name='querySearch'
        deleteHandler={this.props.resetSearchQuery}
        label={searchQuery}
      />);
    }
    this.setState(prevState => ({filters: {...prevState.filters, selectedFilter: elements}}));
  }

  public getStatusOptions(): any {
    let statusOptions: any = [];
    const {t} = this.props;
    STATUS_LIST.forEach((status) => {
      statusOptions.push({
        value: status,
        label: t(`status.${status}`)
      })
    })

    return statusOptions;
  }

  public async fetchSelectListOptions(): Promise<void> {
    const [
      networkTypes,
      interventionTypes,
      interventionTowns
    ] = await Promise.all([
      referenceDataService.getOptions(ReferenceDataEndpoints.OPTIONS.NETWORK_TYPES),
      referenceDataService.getOptions(ReferenceDataEndpoints.OPTIONS.INTERVENTION_TYPES),
      referenceDataService.getOptions(ReferenceDataEndpoints.OPTIONS.INTERVENTION_TOWNS),
    ]);

    const toOptions = (values: string[] = []) => values.map(value => ({value, label: value.toUpperCase()}));

    this.setState(prevState => ({
      selectListOptions: {
        ...prevState.selectListOptions,
        networkTypeOptions: toOptions(networkTypes),
        interventionTypeOptions: toOptions(interventionTypes),
        interventionTownOptions: toOptions(interventionTowns),
      }
    }));
  }

  public componentDidUpdate(prevProps: any): void {
    const {searchQuery} = this.props
    if (prevProps.searchQuery !== searchQuery) {
      this.refreshSelectedFilters(this.props.filter)
    }
  }

  public render(): JSX.Element {
    const [schema] = getFormatedForm(filterListModel);
    const {isValid, selectedFilter, startDate, endDate, focusedInput} = this.state.filters as FiltersState;
    const {t, type, toggleFilters, showFilters, className} = this.props;
    /*
        Don't use conditional rendering to handle displaying FilterList.
        FilterList should always be mounted, otherwise, hiding / showing the filters will reset it.
        Use a class to handle the actual toggling.
    */
    const defaultFilterClassesControl = classnames(
      'position-absolute',
      'box-shadow',
      'ptn-5',
      'z-request-filter',
      'align-items-stretch',
    );

    const filterClassesControl = classnames(
      className ?? defaultFilterClassesControl,
      {
        'd-none': !showFilters,
        'col-3': type !== 'intervention',
      }
    );

    const triggerFilters = (): void => {
      this.triggerFilters();

      if (toggleFilters) {
        toggleFilters();
      }
    };

    return (<>
      <div className="row mb-4">
        <Formik
          validationSchema={schema}
          onSubmit={() => {
          }}
          initialValues={this.state.filters}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {
            ({
               submitForm,
               setErrors
             }) => {
              schema.isValid(this.state.filters).then((isValidForm: any) => {
                if (isValidForm !== isValid) {
                  setErrors({});
                  this.setState(prevState => ({filters: {...prevState.filters, isValid: isValidForm}}));
                }
              });

              return (
                <Form className={'col-12'} onSubmit={(e) => {
                  e.preventDefault();
                  if ((!isValid)) {
                    submitForm();
                  } else {
                    this.triggerFilters();
                  }
                }}>
                  <SzBox className="filter-tag-box" tag="span">
                    {selectedFilter}
                  </SzBox>
                  <SzBox className={filterClassesControl} tag="div">
                    {type === 'intervention' &&
                        <div className="row mt-3">
                            <div className="col-2 pr-2">
                                <SzSelect
                                    id="select-status"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.status.name}
                                    placeholder={t("filter.status")}
                                    onChange={this.changeHandle.bind(this, 'status')}
                                    options={this.getStatusOptions()}
                                    value={this.state.filters.status}
                                    isClearable={false}
                                />
                            </div>
                            <div className="col-2 pr-2">
                                <SzInput
                                    id="input-asset"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.asset.name}
                                    placeholder={t("filter.asset")}
                                    onChange={this.changeHandle.bind(this, 'asset')}
                                    value={this.state.filters.asset}
                                />
                            </div>
                            <div className="col-2 pr-2">
                                <SzInput
                                    id="input-demande"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.demande.name}
                                    placeholder={t("filter.demande")}
                                    onChange={this.changeHandle.bind(this, 'demande')}
                                    value={this.state.filters.demande}
                                />
                            </div>
                            <div className="col-2 pr-2">
                                <SzInput
                                    id="input-numeroIntervention"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.numeroIntervention.name}
                                    placeholder={t("filter.numeroIntervention")}
                                    onChange={this.changeHandle.bind(this, 'numeroIntervention')}
                                    value={this.state.filters.numeroIntervention}
                                />
                            </div>
                            <div className="col-2 pr-2">
                                <SzSelect
                                    id="select-libelleIntervention"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.libelleIntervention.name}
                                    placeholder={t("filter.interventionType")}
                                    onChange={this.changeHandle.bind(this, 'libelleIntervention')}
                                    options={this.state.selectListOptions.interventionTypeOptions}
                                    value={this.state.filters.libelleIntervention}
                                    isClearable={false}
                                />
                            </div>
                            <div className="col-2 pr-2">
                                <SzSelect
                                    id="select-libelleCommune"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.libelleCommune.name}
                                    placeholder={t("filter.town")}
                                    onChange={this.changeHandle.bind(this, 'libelleCommune')}
                                    options={this.state.selectListOptions.interventionTownOptions}
                                    value={this.state.filters.libelleCommune}
                                    isClearable={false}
                                />
                            </div>
                            <div className="col-2 pr-2">
                                <SzInput
                                    id="input-address"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.address.name}
                                    placeholder={t("filter.address")}
                                    onChange={this.changeHandle.bind(this, 'address')}
                                    value={this.state.filters.address}
                                />
                            </div>
                            <div className="col-2 pr-2">
                                <SzSelect
                                    id="select-codeSousDomaine"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.codeSousDomaine.name}
                                    placeholder={t("filter.networkType")}
                                    onChange={this.changeHandle.bind(this, 'codeSousDomaine')}
                                    options={this.state.selectListOptions.networkTypeOptions}
                                    value={this.state.filters.codeSousDomaine}
                                    isClearable={false}
                                />
                            </div>
                        </div>
                    }
                    {type === 'intervention' &&
                        <div className="row">
                            <div className="col-2 pr-2">
                                <SzInput
                                    id="input-idvicr"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.idvicr.name}
                                    placeholder={t("filter.idvicr")}
                                    onChange={this.changeHandle.bind(this, 'idvicr')}
                                    value={this.state.filters.idvicr}
                                />
                            </div>


                            <div className="col-4 pr-2 request-range-filter">
                                <SzDatePicker
                                    dateRange={true}
                                    onChangeRangeDate={({startDate, endDate}: any) => {
                                      this.setState(prevState => ({
                                        filters: {
                                          ...prevState.filters,
                                          startDate,
                                          endDate
                                        }
                                      }));
                                    }}
                                    startDate={startDate}
                                    endDate={endDate}
                                    newVersion={true}
                                    startDatePlaceholderText={t('filter.start_label')}
                                    endDatePlaceholderText={t('filter.end_label')}
                                    startDateId={`sz-date-picker-range-start`}
                                    endDateId={`sz-date-picker-range-end`}
                                    focusedInput={focusedInput}
                                    onFocusChange={(focusedInput: any) => this.setState(prevState => ({
                                      filters: {
                                        ...prevState.filters,
                                        focusedInput
                                      }
                                    }))}
                                />
                            </div>
                            <div className="col-2 pt-4">
                                <SzCheckbox
                                    id="checkbox-document"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.document.name}
                                    onChange={this.changeHandle.bind(this, 'document')}
                                    checked={this.state.filters.document}
                                    label={t('filter.document')}
                                    type="checkbox"
                                />
                            </div>
                            <div className="col-2 pt-4">
                                <SzCheckbox
                                    id="checkbox-itv"
                                    className="mb-3 border-secondary"
                                    name={filterListModel.itv.name}
                                    onChange={this.changeHandle.bind(this, 'itv')}
                                    checked={this.state.filters.itv}
                                    label={t('filter.itv')}
                                    type="checkbox"
                                />
                            </div>
                        </div>
                    }

                    <div className="d-flex justify-content-end">
                      <SzButton
                        className="float-right mr-2"
                        onClick={this.resetFilters}
                      >{t('filter.reinitialize')}
                      </SzButton>


                      <SzButton
                        className="float-right ml-2"
                        onClick={triggerFilters}
                      >{t('filter.filter')}
                      </SzButton>
                    </div>
                  </SzBox>
                </Form>
              )
            }
          }
        </Formik>
      </div>
    </>)
  }

  resetFilters = (): void => {
    this.setState(({filters: this.defaultStateFilters}), () => this.triggerFilters());
  }

  deleteSelectedFilterHandler = (propName: string, value: string) => {
    let nextState: any = {};
    const filters: any = {...this.state.filters};

    if (propName === 'rangeDate') {
      this.setState(prevState => ({filters: {...prevState.filters, startDate: null, endDate: null}}));
      nextState['startDate'] = null;
      nextState['endDate'] = null;
    } else if (propName === 'asset') {
      this.setState(prevState => ({filters: {...prevState.filters, asset: ""}}));
    } else if (propName === 'demande') {
      this.setState(prevState => ({filters: {...prevState.filters, demande: ""}}));
    } else if (propName === 'address') {
      this.setState(prevState => ({filters: {...prevState.filters, address: ""}}));
    } else if (propName === "idvicr") {
      this.setState(prevState => ({filters: {...prevState.filters, idvicr: ""}}));
    } else if (propName === "document") {
      this.setState(prevState => ({filters: {...prevState.filters, document: false}}));
    } else if (propName === "itv") {
      this.setState(prevState => ({filters: {...prevState.filters, itv: false}}));
    } else if (propName === "intervention") {
      this.setState(prevState => ({filters: {...prevState.filters, intervention: false}}));
    } else {
      if (Array.isArray(filters[propName])) {
        nextState[propName] = filters[propName].filter(function (
          filter: any
        ) {
          return filter.value !== value;
        });
      } else {
        nextState[propName] = null;
      }
    }
    this.setState(
      prevState => ({filters: {...prevState.filters, ...nextState}}),
      (): void => this.triggerFilters(),
    );
  };
}

export default withTranslation()(FilterList);
